import React from "react";
import styles from "./Benefit.module.css";

// import your icons (svg/png)
import parseIcon from "../../../Images/parseIcon.svg";
import skillIcon from "../../../Images/parseIcon.svg";
import uploadIcon from "../../../Images/parseIcon.svg";
import filtersIcon from "../../../Images/parseIcon.svg";

const features = [
  {
    icon: parseIcon,
    text: "AI-powered parsing & ranking of resumes",
  },
  {
    icon: skillIcon,
    text: "Skill, experience, and role-based candidate scoring",
  },
  {
    icon: uploadIcon,
    text: "Bulk upload & instant analysis of hundreds of resumes",
  },
  {
    icon: filtersIcon,
    text: "Customizable filters for precise shortlisting",
  },
];

const Features = () => {
  return (
    <section className={styles.features}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          Who Can Benefit from <br /> AI Resume Screening?
        </h2>

        <div className={styles.grid}>
          {features.map((item, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.iconWrapper}>
                <img src={item.icon} alt="feature icon" />
              </div>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
